import { render, staticRenderFns } from "./getImmediateVibration.vue?vue&type=template&id=102a8ca1&scoped=true&"
import script from "./getImmediateVibration.vue?vue&type=script&lang=js&"
export * from "./getImmediateVibration.vue?vue&type=script&lang=js&"
import style0 from "./getImmediateVibration.vue?vue&type=style&index=0&id=102a8ca1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102a8ca1",
  null
  
)

export default component.exports